export const DecryptStatus = {
  SUCCESS: 'SUCCESS',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
} as const;
